import React from 'react';
import './App.css';
import AppRoutes from './app/routes/routes';
import CustomCursor from './components/atoms/CustomCursor/CustomCursor';
import useLenis from './atoms/hooks/useLenis';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useClarityPageView } from "./app/utils/useClarityPageView";
import { useFirebasePageView } from "./app/utils/useFirebasePageView";



function App() {
   useClarityPageView();
   useFirebasePageView();
   useLenis();


  return (
    <div>
      <CustomCursor />
      <AppRoutes />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="dark"
      />
    </div>
  );
}

export default App;
